<template>
	<div class="mt-4 mb-5">
		<!-- Basic Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">Basic Details</span> <span
						class="badge badge-success">LIVE</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Domain Name</span>
				<strong class="d-block text-danger">{{ account.domain }}</strong>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Domain Type</span>
				<span class="d-block">{{ (account.type === 'Primary Domain') ? account.type : `${account.type} under ${account.addonPrimaryDomain}` }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Plan Name</span>
				<span class="d-block">{{ account.planName }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-2">
				<span class="col-mb d-block">Server IP</span>
				<span class="d-block">{{ account.serverIP }}</span>
			</div>
			<div class="col-12">
				<a v-if="account.siteLock && account.siteLock.status === 'Yes'" :href="'https://'+account.siteLock.username +':'+account.siteLock.password +'@'+ account.domain+'/wp-admin/'" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">Open WP Admin</a>
				<a v-else :href="`https://${account.domain}/wp-admin/`" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">Open WP Admin</a>
				<a :href="`https://www.bigscoots.com/comparison/show?comparision_id=${account.comparisonID}`" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary" v-if="account.comparisonID !== ''">Checkout Speed Comparison</a>
				<hr>
			</div>
		</div>
		<!-- Basic Details - End -->
		<!-- Site Details - Start -->
		<site-lock :account="account" :envType="envType" :collaboration="collaboration" :supervisor="supervisor"></site-lock>
		<!-- Site Details - End -->
		<!-- FTP Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">FTP Details</span> <span
						class="badge badge-success">LIVE</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Host</span>
				<span class="d-block">
					{{ account.ftp.host }} <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.ftp.host)"></i>
				</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Port</span>
				<span class="d-block">{{ account.ftp.port }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Mode</span>
				<span class="d-block">{{ account.ftp.mode }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">PASV</span>
				<span class="d-block">{{ account.ftp.pasv }}</span>
			</div>
			<!--<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Username</span>
				<span class="d-block">{{ account.ftp.username }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Password</span>
				<span class="d-block">{{ account.ftp.password }}</span>
			</div>-->
			<div class="col-12">
				<ftp-list :account="account" :envType="envType"></ftp-list>
			</div>
			<div class="col-12">
				<hr>
			</div>
		</div>
		<!-- FTP Details - END -->
		<!-- phpMyAdmin Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">phpMyAdmin Details</span> <span
						class="badge badge-success">LIVE</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.phpMyAdmin.popupUsername !== ''">
				<span class="col-mb d-block">Popup Username</span>
				<span class="d-block">{{ account.phpMyAdmin.popupUsername }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.popupUsername)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.phpMyAdmin.popupPassword !== ''">
				<span class="col-mb d-block">Popup Password</span>
				<span class="d-block">{{ account.phpMyAdmin.popupPassword }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.popupPassword)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Login Username</span>
				<span class="d-block">{{ account.phpMyAdmin.username }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.username)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-2">
				<span class="col-mb d-block">Login Password</span>
				<span class="d-block">{{ account.phpMyAdmin.password }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.password)"></i></span>
			</div>
			<div class="col-12">
				<a :href="account.phpMyAdmin.url" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary" v-if="account.phpMyAdmin.url !== ''">Open phpMyAdmin Portal</a>
				<hr>
			</div>
		</div>
		<!-- phpMyAdmin details - end -->
		<!-- Cloudflare & nameserver Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">Cloudflare &amp; Nameserver Details</span> <span
						class="badge badge-success">LIVE</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Username</span>
				<span class="d-block">{{ account.cloudflare.username }}
					<i v-if="account.cloudflare.username !== '' && account.cloudflare.username != 'NA'" class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.cloudflare.username)"></i>
				</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Password</span>
				<span class="d-block">{{ account.cloudflare.password }}
					<i v-if="account.cloudflare.password !== '' && account.cloudflare.password != 'NA'" class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.cloudflare.password)"></i>
				</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.cloudflare.userKey !== '' && account.cloudflare.userKey != 'NA'">
				<span class="col-mb d-block">User Key</span>
				<span class="d-block">{{ account.cloudflare.userKey }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.cloudflare.userKey)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Nameserver 1</span>
				<strong class="d-block text-danger">{{ account.cloudflare.nameserver1 }}
					<i v-if="account.cloudflare.nameserver2 && account.cloudflare.nameserver2 != 'NA.ns.cloudflare.com'" class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.cloudflare.nameserver1)"></i>
				</strong>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Nameserver 2</span>
				<strong class="d-block text-danger">{{ account.cloudflare.nameserver2 }}
					<i  v-if="account.cloudflare.nameserver2 && account.cloudflare.nameserver2 != 'NA.ns.cloudflare.com'" class="fa fa-copy btn btn-link text-primary" @click="doCopy( account.cloudflare.nameserver2)"></i>
				</strong>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.cloudflare.apiKey !== '' && account.cloudflare.apiKey != 'NA'">
				<span class="col-mb d-block">API Key</span>
				<span class="d-block">{{ account.cloudflare.apiKey }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.cloudflare.apiKey)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.cloudflare.zone_id && account.cloudflare.zone_id != 'NA'">
				<span class="col-mb d-block">Zone ID</span>
				<span class="d-block">{{ account.cloudflare.zone_id }}
					<i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.cloudflare.zone_id)"></i>
				</span>
			</div>
			<div class="col-12">
				<hr>
			</div>
		</div>
		<!-- Cloudflare & nameserver Details - End -->
		<!-- Disk Details - Start -->
		<div class="row" v-if="account.diskSpace !== undefined && account.diskSpace.length > 0">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">Disk space</span><span
						class="badge badge-success">LIVE</span>
				</div>
			</div>
			<div class="col-sm-12">
				<div class="col-mb d-block" v-for="(item, index) in account.diskSpace" :key="item.title">
					<hr v-if="index == 2">
					{{item.name}}: <strong>{{item.size}}{{item.value}}</strong>
				</div>
			</div>
		</div>
		<!-- Disk Details - End -->
	</div>
</template>

<script>
	import copyButtonMixin from "../../../../mixins/copyButtonMixin";
	import SiteLock from './SiteLock'

	export default {
		name: "LiveHostingDetails",
		mixins: [copyButtonMixin],
		props: {
			account: {
				type: Object,
				required: true
			},
			envType: {
				type: String,
				required: true
			},
			collaboration: {
				type: Boolean,
				required: false
			},
			supervisor: {
				type: Object,
				required: false,
				default() {return {};}
			}
		},
		computed: {
			userToken() {
				return this.$store.getters.getUserToken;
			},
			accounts() {
				return this.$store.getters["hosting/accounts"];
			}
		},
		components: {
			SiteLock,
			FtpList: () =>
				import(/* webpackChunkName: "FtpList" */ "./Ftp/FtpList"),
		}
	}
</script>

